
import { defineComponent } from 'vue'
import { iContent } from '../GlossaryDefinition'
import Dialog from 'primevue/dialog'
import glossaryDefinitionDialogDescriptor from './GlossaryDefinitionDialogDescriptor.json'
import Textarea from 'primevue/textarea'

export default defineComponent({
    name: 'glossary-definition-node-dialog',
    components: { Dialog, Textarea },
    emits: ['close', 'save'],
    props: {
        visible: { type: Boolean },
        selectedContent: { type: Object }
    },
    watch: {
        selectedContent() {
            this.loadContent()
        }
    },
    data() {
        return {
            glossaryDefinitionDialogDescriptor,
            content: {} as iContent,
            contentNameDirty: false
        }
    },
    computed: {
        descriptionHelp(): string {
            return (this.content.CONTENT_DS?.length ?? '0') + ' / 500'
        },
        buttonDisabled(): boolean {
            return this.content.CONTENT_NM?.length === 0
        }
    },
    created() {
        this.loadContent()
    },
    methods: {
        loadContent() {
            this.contentNameDirty = false
            this.content = { ...this.selectedContent } as iContent
        }
    }
})
